import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import "./Style.scss";

/**
 * Responsible for rendering the empty version statement
 */
export const VersionEmptyState: React.FC = () => {
  const { t: translate } = useTranslation();

  return(
    <div className="ebt-version-list">
      <h3 className="ebt-version-list__empty-state-title">{translate("Versioning.EmptyStateMessage.Title")}</h3>
      <div className="ebt-version-list__empty-state-description">
        <label>{translate("Versioning.EmptyStateMessage.Description.Line1")}</label>
        <label>{translate("Versioning.EmptyStateMessage.Description.Line2")}</label>
        <label>{translate("Versioning.EmptyStateMessage.Description.Line3")}</label>
      </div>
    </div>
  );
};
